import React from "react"
import autobind from "class-autobind"
import { Card, CardHeader, CardText } from "material-ui"
import { EWorkflowTaskTypeEnum, ITaskDocument } from "../../models"
import TaskTypeIntercomTour from "./TaskTypes/TaskTypeIntercomTour"
import TaskTypeStandard from "./TaskTypes/TaskTypeStandard"
import TaskTypeYouTube from "./TaskTypes/TaskTypeYouTube"
import * as api from "../../api"
import moment from "moment"
import * as workflowActions from "../../actions/WorkflowActions"
import TaskTypeSMSAppLink from "./TaskTypes/TaskTypeSMSAppLink"
import AuthenticationStore from "../../stores/AuthenticationStore"
interface IProps {
    task: ITaskDocument
    onReload():void
}

interface IState {
}

export default class TaskCard extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
        }
        autobind(this)
    }

    completeTask(taskId) {
        api.closeTask(taskId).then(() => {
            this.props.onReload()
            workflowActions.fetchUserWorkflows(AuthenticationStore.getCookieUserId())
        })
    }

    render() {
        const avitarUrl = this.props.task.Completed ?
            "https://findd-prod-assets.s3.us-west-2.amazonaws.com/web/icon-assets/check-avitar.svg" :
            "https://findd-prod-assets.s3.us-west-2.amazonaws.com/web/icon-assets/working-avitar.svg"

        const task = this.props.task;
        const dueDate = moment(task.DueDate)
        const title = `Task #${task.Order} ${task.Title}`
        const subTitle = `${task.Description}${!task.Completed && dueDate.year() > 1 ? ` Due: ${dueDate.utc().format("MM/DD/YYYY")}` : ""}`

        return (
            <Card
            /*expanded={!this.props.task.Completed}*/
            >
                <CardHeader
                    title={title}
                    subtitle={subTitle}
                    actAsExpander={true}
                    showExpandableButton={true}
                    avatar={avitarUrl}
                />
                <CardText expandable={true}>
                    {task.TaskType.TaskType === EWorkflowTaskTypeEnum.StandardTask &&
                        <TaskTypeStandard task={task} onReload={this.props.onReload} onCompleteTask={this.completeTask} />
                    }
                    {task.TaskType.TaskType === EWorkflowTaskTypeEnum.IntercomTourTrigger &&
                        <TaskTypeIntercomTour task={task} onCompleteTask={this.completeTask} />
                    }
                    {task.TaskType.TaskType === EWorkflowTaskTypeEnum.YouTube &&
                        <TaskTypeYouTube task={task} onCompleteTask={this.completeTask} />
                    }
                    {task.TaskType.TaskType === EWorkflowTaskTypeEnum.TextMobileIntro &&
                        <TaskTypeSMSAppLink task={task} onCompleteTask={this.completeTask} />
                    }
                </CardText>
            </Card>
        )
    }
}